// Shared enums and models used across multiple routines.

export enum EntityType {
    location = "location",
    organization = "organization",
    item = "item",
    topic = "topic",
    person = "person",
    event = "event",
}

export type Entity = {
    name: string;
    type: EntityType;
    tag_id?: string | null;
};

export type EventEvidence = {
    quote: string;
    validated?: boolean;
    page_start?: number | null;
};

export type Event = {
    name: string;
    date?: string | null;
    description?: string | null;
    evidence?: EventEvidence | null;
    tag_id?: string | null;
};

export enum PersonRole {
    PARTICIPANT = "participant",
    MENTIONED = "mentioned",
    SIGNER = "signer",
    AUTHOR = "author",
    PARTY = "party",
    WITNESS = "witness",
    NOTARY = "notary",
    ATTORNEY = "attorney",
    JUDGE = "judge",
    PLAINTIFF = "plaintiff",
    DEFENDANT = "defendant",
    AUDITOR = "auditor",
    PREPARER = "preparer",
    REVIEWER = "reviewer",
    ADDRESSEE = "addressee",
}

export enum EmailRole {
    SENDER = "sender",
    RECIPIENT = "recipient",
    CC = "cc",
    BCC = "bcc",
}

export enum TranscriptRole {
    EXAMINER = "examiner",
    DEPONENT = "deponent",
    JUDGE = "judge",
    COURT_REPORTER = "court_reporter",
    VIDEOGRAPHER = "videographer",
    INTERPRETER = "interpreter",
    OTHER_COUNSEL = "other_counsel",
    SPEAKER = "speaker",
}

export enum PersonSource {
    EMAIL_HEADER = "email_header",
    EMAIL_X_HEADER = "email_x_header",
    DOCUMENT_HEADER = "document_header",
    SIGNATURE_BLOCK = "signature_block",
    BODY_CONTENT = "body_content",
    METADATA = "metadata",
    INFERRED = "inferred",
}

export type Person = {
    name: string;
    email?: string | null;
    role: PersonRole;
    email_role?: EmailRole | null;
    transcript_role?: TranscriptRole | null;
    source?: PersonSource | null;
    is_original?: boolean;
    organization?: string | null;
    title?: string | null;
    description?: string | null;
    tag_id?: string | null;
};
